module.exports = __webpack_public_path__ + "static/media/column-view.8ba0f53a.svg";